// @ts-nocheck
import React from 'react';
import { NavLink } from 'react-router-dom';

function GameNameCell({ name, id, editable }) {
  return (
    <div className="grid-game-name">
      <NavLink to={`/game/${id}`} className="game-title">
        {name}
      </NavLink>
    </div>
  );
}

export default GameNameCell;
